const co2_x = [
"Mar,1958",
"Apr,1958",
"May,1958",
"Jun,1958",
"JUL,1958",
"Aug,1958",
"Sep,1958",
"Oct,1958",
"Nov,1958",
"Dec,1958",
"Jan,1959",
"Feb,1959",
"Mar,1959",
"Apr,1959",
"May,1959",
"Jun,1959",
"JUL,1959",
"Aug,1959",
"Sep,1959",
"Oct,1959",
"Nov,1959",
"Dec,1959",
"Jan,1960",
"Feb,1960",
"Mar,1960",
"Apr,1960",
"May,1960",
"Jun,1960",
"JUL,1960",
"Aug,1960",
"Sep,1960",
"Oct,1960",
"Nov,1960",
"Dec,1960",
"Jan,1961",
"Feb,1961",
"Mar,1961",
"Apr,1961",
"May,1961",
"Jun,1961",
"JUL,1961",
"Aug,1961",
"Sep,1961",
"Oct,1961",
"Nov,1961",
"Dec,1961",
"Jan,1962",
"Feb,1962",
"Mar,1962",
"Apr,1962",
"May,1962",
"Jun,1962",
"JUL,1962",
"Aug,1962",
"Sep,1962",
"Oct,1962",
"Nov,1962",
"Dec,1962",
"Jan,1963",
"Feb,1963",
"Mar,1963",
"Apr,1963",
"May,1963",
"Jun,1963",
"JUL,1963",
"Aug,1963",
"Sep,1963",
"Oct,1963",
"Nov,1963",
"Dec,1963",
"Jan,1964",
"Feb,1964",
"Mar,1964",
"Apr,1964",
"May,1964",
"Jun,1964",
"JUL,1964",
"Aug,1964",
"Sep,1964",
"Oct,1964",
"Nov,1964",
"Dec,1964",
"Jan,1965",
"Feb,1965",
"Mar,1965",
"Apr,1965",
"May,1965",
"Jun,1965",
"JUL,1965",
"Aug,1965",
"Sep,1965",
"Oct,1965",
"Nov,1965",
"Dec,1965",
"Jan,1966",
"Feb,1966",
"Mar,1966",
"Apr,1966",
"May,1966",
"Jun,1966",
"JUL,1966",
"Aug,1966",
"Sep,1966",
"Oct,1966",
"Nov,1966",
"Dec,1966",
"Jan,1967",
"Feb,1967",
"Mar,1967",
"Apr,1967",
"May,1967",
"Jun,1967",
"JUL,1967",
"Aug,1967",
"Sep,1967",
"Oct,1967",
"Nov,1967",
"Dec,1967",
"Jan,1968",
"Feb,1968",
"Mar,1968",
"Apr,1968",
"May,1968",
"Jun,1968",
"JUL,1968",
"Aug,1968",
"Sep,1968",
"Oct,1968",
"Nov,1968",
"Dec,1968",
"Jan,1969",
"Feb,1969",
"Mar,1969",
"Apr,1969",
"May,1969",
"Jun,1969",
"JUL,1969",
"Aug,1969",
"Sep,1969",
"Oct,1969",
"Nov,1969",
"Dec,1969",
"Jan,1970",
"Feb,1970",
"Mar,1970",
"Apr,1970",
"May,1970",
"Jun,1970",
"JUL,1970",
"Aug,1970",
"Sep,1970",
"Oct,1970",
"Nov,1970",
"Dec,1970",
"Jan,1971",
"Feb,1971",
"Mar,1971",
"Apr,1971",
"May,1971",
"Jun,1971",
"JUL,1971",
"Aug,1971",
"Sep,1971",
"Oct,1971",
"Nov,1971",
"Dec,1971",
"Jan,1972",
"Feb,1972",
"Mar,1972",
"Apr,1972",
"May,1972",
"Jun,1972",
"JUL,1972",
"Aug,1972",
"Sep,1972",
"Oct,1972",
"Nov,1972",
"Dec,1972",
"Jan,1973",
"Feb,1973",
"Mar,1973",
"Apr,1973",
"May,1973",
"Jun,1973",
"JUL,1973",
"Aug,1973",
"Sep,1973",
"Oct,1973",
"Nov,1973",
"Dec,1973",
"Jan,1974",
"Feb,1974",
"Mar,1974",
"Apr,1974",
"May,1974",
"Jun,1974",
"JUL,1974",
"Aug,1974",
"Sep,1974",
"Oct,1974",
"Nov,1974",
"Dec,1974",
"Jan,1975",
"Feb,1975",
"Mar,1975",
"Apr,1975",
"May,1975",
"Jun,1975",
"JUL,1975",
"Aug,1975",
"Sep,1975",
"Oct,1975",
"Nov,1975",
"Dec,1975",
"Jan,1976",
"Feb,1976",
"Mar,1976",
"Apr,1976",
"May,1976",
"Jun,1976",
"JUL,1976",
"Aug,1976",
"Sep,1976",
"Oct,1976",
"Nov,1976",
"Dec,1976",
"Jan,1977",
"Feb,1977",
"Mar,1977",
"Apr,1977",
"May,1977",
"Jun,1977",
"JUL,1977",
"Aug,1977",
"Sep,1977",
"Oct,1977",
"Nov,1977",
"Dec,1977",
"Jan,1978",
"Feb,1978",
"Mar,1978",
"Apr,1978",
"May,1978",
"Jun,1978",
"JUL,1978",
"Aug,1978",
"Sep,1978",
"Oct,1978",
"Nov,1978",
"Dec,1978",
"Jan,1979",
"Feb,1979",
"Mar,1979",
"Apr,1979",
"May,1979",
"Jun,1979",
"JUL,1979",
"Aug,1979",
"Sep,1979",
"Oct,1979",
"Nov,1979",
"Dec,1979",
"Jan,1980",
"Feb,1980",
"Mar,1980",
"Apr,1980",
"May,1980",
"Jun,1980",
"JUL,1980",
"Aug,1980",
"Sep,1980",
"Oct,1980",
"Nov,1980",
"Dec,1980",
"Jan,1981",
"Feb,1981",
"Mar,1981",
"Apr,1981",
"May,1981",
"Jun,1981",
"JUL,1981",
"Aug,1981",
"Sep,1981",
"Oct,1981",
"Nov,1981",
"Dec,1981",
"Jan,1982",
"Feb,1982",
"Mar,1982",
"Apr,1982",
"May,1982",
"Jun,1982",
"JUL,1982",
"Aug,1982",
"Sep,1982",
"Oct,1982",
"Nov,1982",
"Dec,1982",
"Jan,1983",
"Feb,1983",
"Mar,1983",
"Apr,1983",
"May,1983",
"Jun,1983",
"JUL,1983",
"Aug,1983",
"Sep,1983",
"Oct,1983",
"Nov,1983",
"Dec,1983",
"Jan,1984",
"Feb,1984",
"Mar,1984",
"Apr,1984",
"May,1984",
"Jun,1984",
"JUL,1984",
"Aug,1984",
"Sep,1984",
"Oct,1984",
"Nov,1984",
"Dec,1984",
"Jan,1985",
"Feb,1985",
"Mar,1985",
"Apr,1985",
"May,1985",
"Jun,1985",
"JUL,1985",
"Aug,1985",
"Sep,1985",
"Oct,1985",
"Nov,1985",
"Dec,1985",
"Jan,1986",
"Feb,1986",
"Mar,1986",
"Apr,1986",
"May,1986",
"Jun,1986",
"JUL,1986",
"Aug,1986",
"Sep,1986",
"Oct,1986",
"Nov,1986",
"Dec,1986",
"Jan,1987",
"Feb,1987",
"Mar,1987",
"Apr,1987",
"May,1987",
"Jun,1987",
"JUL,1987",
"Aug,1987",
"Sep,1987",
"Oct,1987",
"Nov,1987",
"Dec,1987",
"Jan,1988",
"Feb,1988",
"Mar,1988",
"Apr,1988",
"May,1988",
"Jun,1988",
"JUL,1988",
"Aug,1988",
"Sep,1988",
"Oct,1988",
"Nov,1988",
"Dec,1988",
"Jan,1989",
"Feb,1989",
"Mar,1989",
"Apr,1989",
"May,1989",
"Jun,1989",
"JUL,1989",
"Aug,1989",
"Sep,1989",
"Oct,1989",
"Nov,1989",
"Dec,1989",
"Jan,1990",
"Feb,1990",
"Mar,1990",
"Apr,1990",
"May,1990",
"Jun,1990",
"JUL,1990",
"Aug,1990",
"Sep,1990",
"Oct,1990",
"Nov,1990",
"Dec,1990",
"Jan,1991",
"Feb,1991",
"Mar,1991",
"Apr,1991",
"May,1991",
"Jun,1991",
"JUL,1991",
"Aug,1991",
"Sep,1991",
"Oct,1991",
"Nov,1991",
"Dec,1991",
"Jan,1992",
"Feb,1992",
"Mar,1992",
"Apr,1992",
"May,1992",
"Jun,1992",
"JUL,1992",
"Aug,1992",
"Sep,1992",
"Oct,1992",
"Nov,1992",
"Dec,1992",
"Jan,1993",
"Feb,1993",
"Mar,1993",
"Apr,1993",
"May,1993",
"Jun,1993",
"JUL,1993",
"Aug,1993",
"Sep,1993",
"Oct,1993",
"Nov,1993",
"Dec,1993",
"Jan,1994",
"Feb,1994",
"Mar,1994",
"Apr,1994",
"May,1994",
"Jun,1994",
"JUL,1994",
"Aug,1994",
"Sep,1994",
"Oct,1994",
"Nov,1994",
"Dec,1994",
"Jan,1995",
"Feb,1995",
"Mar,1995",
"Apr,1995",
"May,1995",
"Jun,1995",
"JUL,1995",
"Aug,1995",
"Sep,1995",
"Oct,1995",
"Nov,1995",
"Dec,1995",
"Jan,1996",
"Feb,1996",
"Mar,1996",
"Apr,1996",
"May,1996",
"Jun,1996",
"JUL,1996",
"Aug,1996",
"Sep,1996",
"Oct,1996",
"Nov,1996",
"Dec,1996",
"Jan,1997",
"Feb,1997",
"Mar,1997",
"Apr,1997",
"May,1997",
"Jun,1997",
"JUL,1997",
"Aug,1997",
"Sep,1997",
"Oct,1997",
"Nov,1997",
"Dec,1997",
"Jan,1998",
"Feb,1998",
"Mar,1998",
"Apr,1998",
"May,1998",
"Jun,1998",
"JUL,1998",
"Aug,1998",
"Sep,1998",
"Oct,1998",
"Nov,1998",
"Dec,1998",
"Jan,1999",
"Feb,1999",
"Mar,1999",
"Apr,1999",
"May,1999",
"Jun,1999",
"JUL,1999",
"Aug,1999",
"Sep,1999",
"Oct,1999",
"Nov,1999",
"Dec,1999",
"Jan,2000",
"Feb,2000",
"Mar,2000",
"Apr,2000",
"May,2000",
"Jun,2000",
"JUL,2000",
"Aug,2000",
"Sep,2000",
"Oct,2000",
"Nov,2000",
"Dec,2000",
"Jan,2001",
"Feb,2001",
"Mar,2001",
"Apr,2001",
"May,2001",
"Jun,2001",
"JUL,2001",
"Aug,2001",
"Sep,2001",
"Oct,2001",
"Nov,2001",
"Dec,2001",
"Jan,2002",
"Feb,2002",
"Mar,2002",
"Apr,2002",
"May,2002",
"Jun,2002",
"JUL,2002",
"Aug,2002",
"Sep,2002",
"Oct,2002",
"Nov,2002",
"Dec,2002",
"Jan,2003",
"Feb,2003",
"Mar,2003",
"Apr,2003",
"May,2003",
"Jun,2003",
"JUL,2003",
"Aug,2003",
"Sep,2003",
"Oct,2003",
"Nov,2003",
"Dec,2003",
"Jan,2004",
"Feb,2004",
"Mar,2004",
"Apr,2004",
"May,2004",
"Jun,2004",
"JUL,2004",
"Aug,2004",
"Sep,2004",
"Oct,2004",
"Nov,2004",
"Dec,2004",
"Jan,2005",
"Feb,2005",
"Mar,2005",
"Apr,2005",
"May,2005",
"Jun,2005",
"JUL,2005",
"Aug,2005",
"Sep,2005",
"Oct,2005",
"Nov,2005",
"Dec,2005",
"Jan,2006",
"Feb,2006",
"Mar,2006",
"Apr,2006",
"May,2006",
"Jun,2006",
"JUL,2006",
"Aug,2006",
"Sep,2006",
"Oct,2006",
"Nov,2006",
"Dec,2006",
"Jan,2007",
"Feb,2007",
"Mar,2007",
"Apr,2007",
"May,2007",
"Jun,2007",
"JUL,2007",
"Aug,2007",
"Sep,2007",
"Oct,2007",
"Nov,2007",
"Dec,2007",
"Jan,2008",
"Feb,2008",
"Mar,2008",
"Apr,2008",
"May,2008",
"Jun,2008",
"JUL,2008",
"Aug,2008",
"Sep,2008",
"Oct,2008",
"Nov,2008",
"Dec,2008",
"Jan,2009",
"Feb,2009",
"Mar,2009",
"Apr,2009",
"May,2009",
"Jun,2009",
"JUL,2009",
"Aug,2009",
"Sep,2009",
"Oct,2009",
"Nov,2009",
"Dec,2009",
"Jan,2010",
"Feb,2010",
"Mar,2010",
"Apr,2010",
"May,2010",
"Jun,2010",
"JUL,2010",
"Aug,2010",
"Sep,2010",
"Oct,2010",
"Nov,2010",
"Dec,2010",
"Jan,2011",
"Feb,2011",
"Mar,2011",
"Apr,2011",
"May,2011",
"Jun,2011",
"JUL,2011",
"Aug,2011",
"Sep,2011",
"Oct,2011",
"Nov,2011",
"Dec,2011",
"Jan,2012",
"Feb,2012",
"Mar,2012",
"Apr,2012",
"May,2012",
"Jun,2012",
"JUL,2012",
"Aug,2012",
"Sep,2012",
"Oct,2012",
"Nov,2012",
"Dec,2012",
"Jan,2013",
"Feb,2013",
"Mar,2013",
"Apr,2013",
"May,2013",
"Jun,2013",
"JUL,2013",
"Aug,2013",
"Sep,2013",
"Oct,2013",
"Nov,2013",
"Dec,2013",
"Jan,2014",
"Feb,2014",
"Mar,2014",
"Apr,2014",
"May,2014",
"Jun,2014",
"JUL,2014",
"Aug,2014",
"Sep,2014",
"Oct,2014",
"Nov,2014",
"Dec,2014",
"Jan,2015",
"Feb,2015",
"Mar,2015",
"Apr,2015",
"May,2015",
"Jun,2015",
"JUL,2015",
"Aug,2015",
"Sep,2015",
"Oct,2015",
"Nov,2015",
"Dec,2015",
"Jan,2016",
"Feb,2016",
"Mar,2016",
"Apr,2016",
"May,2016",
"Jun,2016",
"JUL,2016",
"Aug,2016",
"Sep,2016",
"Oct,2016",
"Nov,2016",
"Dec,2016",
"Jan,2017",
"Feb,2017",
"Mar,2017",
"Apr,2017",
"May,2017",
"Jun,2017",
"JUL,2017",
"Aug,2017",
"Sep,2017",
"Oct,2017",
"Nov,2017",
"Dec,2017",
"Jan,2018",
"Feb,2018",
"Mar,2018",
"Apr,2018",
"May,2018",
"Jun,2018",
"JUL,2018",
"Aug,2018",
"Sep,2018",
"Oct,2018",
"Nov,2018",
"Dec,2018",
"Jan,2019",
"Feb,2019",
"Mar,2019",
"Apr,2019",
"May,2019",
"Jun,2019",
"JUL,2019",
"Aug,2019",
"Sep,2019",
"Oct,2019",
"Nov,2019",
"Dec,2019",
"Jan,2020",
"Feb,2020",
"Mar,2020",
"Apr,2020",
"May,2020",
"Jun,2020",
"JUL,2020",
"Aug,2020",
"Sep,2020",
"Oct,2020",
"Nov,2020",
"Dec,2020",
"Jan,2021",
"Feb,2021",
"Mar,2021",
"Apr,2021",
"May,2021",
"Jun,2021",
"JUL,2021",
"Aug,2021",
"Sep,2021",
"Oct,2021",
"Nov,2021",
"Dec,2021",
"Jan,2022",
"Feb,2022",
"Mar,2022",
"Apr,2022",
"May,2022",
"Jun,2022",
"JUL,2022",
"Aug,2022",    
]

export default co2_x